import Vue from 'vue';
import Swal from 'vue-sweetalert2';

Vue.use(Swal);
